<span [innerHTML]="currentWord"></span>